import React from 'react';

import { OrderType } from 'enums';
import { Statistics } from 'features/statistics';

export const TechOperatorPayinStatisticsPage: React.FC = () => (
  <Statistics orderType={OrderType.Payin} />
);
export const TechOperatorPayoutStatisticsPage: React.FC = () => (
  <Statistics orderType={OrderType.Payout} />
);
